import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { CompanyMembersService } from '../services/companyMembers.service';
import { toast } from 'sonner';

export function useCompanyMembers(companyId: string) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['company-members', companyId],
    queryFn: () => CompanyMembersService.getMembers(companyId),
    enabled: !!companyId,
  });

  const inviteMutation = useMutation({
    mutationFn: ({ email, roleCode }: { email: string; roleCode: string }) => 
      CompanyMembersService.inviteMember(companyId, email, roleCode),
    onSuccess: () => {
      toast.success('Đã gửi lời mời tham gia');
    },
    onError: (error: any) => {
      toast.error('Lỗi khi gửi lời mời: ' + error.message);
    }
  });

  const updateRoleMutation = useMutation({
    mutationFn: ({ memberId, roleCode }: { memberId: string; roleCode: string }) => 
      CompanyMembersService.updateMemberRole(memberId, roleCode),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['company-members', companyId] });
      toast.success('Đã cập nhật vai trò thành viên');
    }
  });

  const removeMutation = useMutation({
    mutationFn: (memberId: string) => CompanyMembersService.removeMember(memberId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['company-members', companyId] });
      toast.success('Đã xóa thành viên khỏi công ty');
    }
  });

  return {
    members: query.data || [],
    isLoading: query.isLoading,
    inviteMember: inviteMutation.mutateAsync,
    updateRole: updateRoleMutation.mutateAsync,
    removeMember: removeMutation.mutateAsync,
    isProcessing: inviteMutation.isPending || updateRoleMutation.isPending || removeMutation.isPending
  };
}
